import Termly from 'termly-namespace'

import client from 'utils/client'
import URL from 'utils/url'


export default function statisticViewApiCall({ eventTypes, impressionLimit }) {
  const postURL = URL.statistic()

  const args = {
    event_types: eventTypes,
    website_uuid: Termly.websiteUUID,
  }

  // biome-ignore lint/suspicious/noDoubleEquals: intentional loose equality for null/undefined check
  if ( impressionLimit != void 0 ) {
    args.impression_limit = impressionLimit
  }

  return client
    .post(postURL, args)
    .catch(({ message }) => {
      console.error('Encountered %o when trying to post statistics to %s',
                    message,
                    postURL)
    })
}
